module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container p-0"
  }, [_c('ul', {
    staticClass: "step clearfix"
  }, [_c('li', {
    class: {
      active: _vm.stepPass(0) === 1
    },
    on: {
      "click": function($event) {
        return _vm.go(0)
      }
    }
  }, [_c('span', {
    staticClass: "step-item"
  }, [_vm._v("1. เลือกจำนวนเงิน")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepPass(1) > 1
    },
    on: {
      "click": function($event) {
        return _vm.go(1)
      }
    }
  }, [_c('span', {
    staticClass: "step-item"
  }, [_vm._v("2. ช่องทางการชำระเงิน")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-395ebb02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-395ebb02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonateStepBar.vue
// module id = 741
// module chunks = 1